import React, { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';
import { AgeVerificationModal } from '../components/AgeVerificationModal';
interface AccessGateContextType {
  openAccessGate: (trigger: HTMLElement) => void;
}
const AccessGateContext = createContext<AccessGateContextType | undefined>(undefined);
export function AccessGateProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLElement | null>(null);
  const openAccessGate = useCallback((trigger: HTMLElement) => {
    triggerRef.current = trigger;
    setIsOpen(true);
  }, []);
  const closeAccessGate = useCallback(() => {
    setIsOpen(false);
    window.setTimeout(() => {
      triggerRef.current?.focus();
      triggerRef.current = null;
    }, 0);
  }, []);
  return <AccessGateContext.Provider value={{
    openAccessGate
  }} data-id="element-366" data-mp="1i6o0zngjtlvq">
      {children}
      <AgeVerificationModal isOpen={isOpen} onClose={closeAccessGate} data-id="element-367" data-mp="1d9nwhgzckr6q" />
    </AccessGateContext.Provider>;
}
export function useAccessGate() {
  const context = useContext(AccessGateContext);
  if (context === undefined) {
    throw new Error('useAccessGate must be used within an AccessGateProvider');
  }
  return context;
}